// extracted by mini-css-extract-plugin
export default {"input":"G9-z","button":"H9-z","selected":"I9-z","unavailable":"J9-z","oos":"K9-z","image":"L9-z","paperCutDisabledOverlay":"M9-z"};